<template>
    <div>
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="p-20">
            <!-- <a-form-item label="行程名称">
                <a-input v-model="dataForm.supplier_name" placeholder="行程名称" />
            </a-form-item> -->
            <a-form-item>
                <a-button type="primary" @click="getDataList">刷新</a-button>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="addOrUpdateHandle('', customer_id)">新增</a-button>
            </a-form-item>
            <a-form-item>
                <a-button type="" @click="copylink">复制手机端链接</a-button>
            </a-form-item>
        </a-form>
        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="id" :loading="dataListLoading"
            :scroll="{}">
            <template slot="department.department_name" slot-scope="department_name">
                <a-tag>{{ department_name }}</a-tag>
            </template>
            <template slot="id_front" slot-scope="id_front">
                <a-button type="link" v-if="id_front" @click="showView(id_front)">点击查看</a-button>
                <a-tag v-else color="red">未上传</a-tag>
            </template>
            <template slot="id_back" slot-scope="id_back">
                <a-button type="link" v-if="id_back" @click="showView(id_back)">点击查看</a-button>
                <a-tag v-else color="red">未上传</a-tag>
            </template>
            <template slot="editBtn" slot-scope="text, row">
                <a-button type="link" class="p-5" @click="addOrUpdateHandle(row.id_info_id, customer_id)">
                    编辑
                </a-button>
                <a-button type="link" class="p-5" @click="deleteHandle(row.id_info_id)">
                    删除
                </a-button>
            </template>
        </a-table>
        <a-pagination class="mt-20 float-right" show-size-changer :current="page" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
            @change="pageCurrentChangeHandle" />
        <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
        <TripProject ref="tripProject"></TripProject>
    </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/idinfoaddorupdate.vue";
import TripProject from "@/components/TripProject/index.vue";
export default {
    mixins: [viewModule],
    components: {
        addorupdate,
        TripProject,
    },
    props: {
        customer_id: String,
    },
    watch: {
        customer_id(newValue) {
            this.dataForm.customer_id = newValue
            this.getDataList()
        }
    },
    data() {
        return {
            mixinViewModuleOptions: {
                getDataListURL: "/admin/idinfo/page",
                deleteURL: "/admin/idinfo/delete",
            },
            dataForm: {
                customer_id: this.customer_id,
            },
            columns: [
                {
                    title: "登记姓名",
                    dataIndex: "id_name",
                },
                {
                    title: "证件类型",
                    dataIndex: "id_type",
                    customRender: (text) => `${text == 1 ? '第二代居民身份证' : text == 2 ? '港澳通行证' : ''}`,
                },
                {
                    title: "证件号码",
                    dataIndex: "id_number",
                },
                {
                    title: "证件正面照",
                    dataIndex: "id_front",
                    scopedSlots: { customRender: "id_front" },
                },
                {
                    title: "证件背面照",
                    dataIndex: "id_back",
                    scopedSlots: { customRender: "id_back" },
                },
                {
                    title: "创建时间",
                    dataIndex: "id_createtime",
                },
                {
                    title: "操作",
                    scopedSlots: { customRender: "editBtn" },
                },
            ],
        };
    },
    methods: {
        addOrUpdateHandle(trip_id, customer_id) {
            this.$refs.addOrUpdate.init(trip_id, customer_id);
        },
        showView(url) {
            this.$viewerApi({
                images: [url],
            });
        },
        copylink() {
            const textarea = document.createElement('textarea');
            //获取当前域名
            const domain = window.location.origin;
            textarea.value = `${domain}/h5/index.html#/?cid=` + this.customer_id;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            console.log('复制成功');
            this.$message.success("复制成功")
        }
    },
};
</script>

<style></style>